import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateMeta } from "../store/actions/metaAction";
import { Link } from "react-router-dom";
import { navbarItems } from "helpers/data/navbar";

const Home = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "الرئيسية",
				breadcrumb: "الرئيسية",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	return (
		<section className="homePage">
			<p>مرحبا بك في لوحة التحكم الخاصة بك</p>
			<ul className="list-inline">

				{
					navbarItems.map((item, index) => (
						<li className="list-inline-item" key={index}>
							<Link to={item.link}>  <i className={`fas mx-2 ${item.icon}`}></i> {item.title} </Link>
						</li>
					))
				}
				
			</ul>
		</section>
	);
};

export default Home;
